// extracted by mini-css-extract-plugin
module.exports = {"clients__item":"style_clients__item__x9dlr","clients__link":"style_clients__link__5gFsN"};